import { render, staticRenderFns } from "./VaultConfig.vue?vue&type=template&id=34835304&scoped=true&"
import script from "./VaultConfig.vue?vue&type=script&lang=js&"
export * from "./VaultConfig.vue?vue&type=script&lang=js&"
import style0 from "./VaultConfig.vue?vue&type=style&index=0&id=34835304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34835304",
  null
  
)

export default component.exports